import {Alert, Box, Button, CircularProgress, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, Grid2 as Grid, TextField, Tooltip} from "@mui/material"
import React, {useState} from "react"
import {useNavigate} from 'react-router-dom';
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {Add, KeyboardArrowDown, KeyboardArrowUp, MoveDown, Remove} from "@mui/icons-material";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import TableHead from "@mui/material/TableHead";
import IconButton from "@mui/material/IconButton";
import {limit} from "../../../util/StringUtils";
import productService from "../../../services/ProductService";

const columns = [
    {id: 'productName', label: 'Termék', fun: (v, r, n) => <span style={{color: 'blue', textDecoration: "underline"}} onClick={() => n(`/dashboard/storage/products/${r.productId}`)}>{limit(v, 50)}</span>},
    {id: 'taskType', label: 'Munkafolyamat', align: 'center'},
    {id: 'requiredAmount', label: 'Teljes Szükséges Mennyiség', align: 'center', fun: (v, r, n, i) => v * (i?.amount ?? 0)},
    {id: 'currentAmount', label: 'Már átmozgatott mennyiség', align: 'center', fun: c => c ? c : '0'},
    {
        id: '', label: 'Státusz', width: '500px', fun: (v, row, n, iteration) => {
            const totalAvailableAmount = row.items?.map(item => (item?.amount ?? 0)).reduce((sum, amt) => sum + amt, 0) ?? 0;
            const otherReservedAmount = row.items?.map(item => item.otherReservedAmount).reduce((sum, amt) => sum + amt, 0) ?? 0;
            const reservedAmount = iteration?.id ? 0 : row.items?.map(item => item.reservedAmount).reduce((sum, amt) => sum + amt, 0) ?? 0;
            const totalReservedAmount = otherReservedAmount + reservedAmount;
            const selectableAmount = totalAvailableAmount - totalReservedAmount;
            const requiredAmount = row.requiredAmount * (iteration?.amount || 0) - row.currentAmount
            return selectableAmount < requiredAmount ?
                <Alert severity="warning" sx={{padding: "5px", margin: "0px", textAlign: "right"}}>Nem áll rendelkezése elegendő ({selectableAmount - requiredAmount})</Alert> :
                <Alert severity="success" sx={{padding: "5px", margin: "0px", textAlign: "right"}}>Megfelelő mennyiség rendelkezésre áll ({selectableAmount - requiredAmount})</Alert>
        }
    }
];

const nestedColumns = [
    {
        id: '', label: '', width: "40px", fun: (v, r, n, h) => <Tooltip title="Termék mozgatása" placement="left">
            <Button
                onClick={(e) => h(r)}
                variant="text" sx={{
                marginLeft: "0px",
                padding: "0px",
                minWidth: "0px"
            }}>
                <MoveDown fontSize="small" color="action"/>
            </Button>
        </Tooltip>
    },
    {
        id: 'location',
        label: 'Lokáció',
        width: "500px",
        fun: (v, r, n) => r.shortageDueToReservations > 0 ?
            <span style={{color: 'blue', textDecoration: "underline", cursor: "pointer"}} onClick={() => n(`/dashboard/product-projects/${r.productProjectId}/iterations/${r.productProjectIterationId}`)}>{v}</span> : v
    },
    {id: 'amount', label: 'Mennyiség', align: 'center'},
    {id: 'otherReservedAmount', label: 'Máshova lefoglalt', align: 'center', fun: r => r ? r : '0'},
    {id: 'reservedAmount', label: 'Ide lefoglalt', align: 'center', fun: r => r ? r : '0'},
];

export default function ProductProjectIterationEditorTemplate(props) {

    const {
        id,
        onChange,
        create,
        update,
        message,
        iteration,
        productProject,
        iterationOptions,
        waitingForServer,
    } = props

    const navigate = useNavigate();

    const [open, setOpen] = useState(false);
    const [dialogContent, setDialogContent] = useState();

    const handleDialogOpen = (row) => {
        console.log(row);
        setDialogContent(row);
        setOpen(true);
    };

    const handleDialogClose = () => {
        setDialogContent(null)
        setOpen(false);
    };

    const visibleColumns = iteration?.id ? nestedColumns : nestedColumns.filter((c, index) => index > 0)

    return (
        <div>
            <Paper component="main">
                <Grid container columns={20}>
                    <Grid size={{xs: 20}}>
                        <div className="register-paper">
                            <form id="login" onSubmit={id ? update : create}>
                                <Grid container columns={20}>
                                    <Grid size={{xs: 20}}>
                                        <Grid container columnSpacing={2} rowSpacing={0} columns={30}>
                                            {id != null && iteration?.id == null ?
                                                <Grid size={{xs: 30}}><CircularProgress sx={{margin: "200px"}}/>
                                                </Grid> :
                                                <>
                                                    {createInputField("amount", "Teljes Mennyiség", iteration?.amount, onChange, true, true, false, 'number')}
                                                    <Grid size={{xs: 20}}></Grid>
                                                    {iteration?.customers?.map((customer, index) => (
                                                        <React.Fragment key={index}>
                                                            <Grid size={{xs: 10}}>
                                                                <TextField
                                                                    variant="outlined"
                                                                    margin="normal"
                                                                    fullWidth
                                                                    label={"Megrendelő " + (index + 1)}
                                                                    name="name"
                                                                    autoComplete="off"
                                                                    onChange={(e) => props.onCustomerChange(e, index)}
                                                                    value={customer.name}
                                                                />

                                                            </Grid>
                                                            <Grid size={{xs: 5}}>
                                                                <TextField
                                                                    variant="outlined"
                                                                    margin="normal"
                                                                    fullWidth
                                                                    label={"Cím"}
                                                                    name="address"
                                                                    autoComplete="off"
                                                                    onChange={(e) => props.onCustomerChange(e, index)}
                                                                    value={customer.address}
                                                                />
                                                            </Grid>
                                                            <Grid size={{xs: 5}}>
                                                                <TextField
                                                                    variant="outlined"
                                                                    margin="normal"
                                                                    fullWidth
                                                                    label={"Adószám"}
                                                                    name="taxNumber"
                                                                    autoComplete="off"
                                                                    onChange={(e) => props.onCustomerChange(e, index)}
                                                                    value={customer.taxNumber}
                                                                />
                                                            </Grid>
                                                            <Grid size={{xs: 5}}>
                                                                <TextField
                                                                    variant="outlined"
                                                                    margin="normal"
                                                                    fullWidth
                                                                    label={"Bankszámla szám"}
                                                                    name="bankAccountNumber"
                                                                    autoComplete="off"
                                                                    onChange={(e) => props.onCustomerChange(e, index)}
                                                                    value={customer.bankAccountNumber}
                                                                />
                                                            </Grid>
                                                            <Grid size={{xs: 5}}>
                                                                <TextField
                                                                    variant="outlined"
                                                                    margin="normal"
                                                                    fullWidth
                                                                    label={"Mennyiség"}
                                                                    name="amount"
                                                                    autoComplete="off"
                                                                    onChange={(e) => props.onCustomerChange(e, index)}
                                                                    value={customer.amount}
                                                                />

                                                            </Grid>
                                                        </React.Fragment>
                                                    ))}
                                                    <Grid size={{xs: 5}} sx={{textAlign: "left", paddingTop: "25px"}}>
                                                        <Button variant='contained' color='error' component={'label'}
                                                                sx={{
                                                                    minWidth: "0px",
                                                                    padding: "0px",
                                                                    marginRight: "10px"
                                                                }}
                                                                onClick={() => props.deleteLastCustomer()}>
                                                            <Remove fontSize="large"/>
                                                        </Button>
                                                        <Button variant='contained' color='info' component={'label'}
                                                                sx={{
                                                                    minWidth: "0px",
                                                                    padding: "0px",
                                                                    marginRight: "10px"
                                                                }}
                                                                onClick={() => props.addNewCustomer()}>
                                                            <Add fontSize="large"/>
                                                        </Button>
                                                    </Grid>
                                                    {message &&
                                                        <Grid size={{xs: 30}}>
                                                            <Alert severity="error" variant="standard"
                                                                   style={{color: "red"}}>{message}</Alert>
                                                        </Grid>
                                                    }
                                                </>
                                            }

                                            <Grid size={{xs: 2, md: 30}} sx={{height: "50px"}}></Grid>

                                            <Grid size={{xs: 8, md: 6, lg: 4}}>
                                                <Button type="button" fullWidth variant="contained" color="error"
                                                        onClick={() => navigate(-1)}>
                                                    Vissza
                                                </Button>
                                            </Grid>

                                            <Grid size={{md: 18, lg: 14}}></Grid>

                                            <Grid size={{xs: 8, md: 6, lg: 4}}>
                                                {id ? (iteration?.status !== 'DONE') ?
                                                    <Tooltip title={"Gyártási ciklus lezárása és az elkészült termékek hozzáadása az azonos nevű alraktárba"}>
                                                        <Button fullWidth variant="contained" color="info" onClick={props.close}>
                                                            Lezárás
                                                        </Button>
                                                    </Tooltip> : <>Lezárt gyártási ciklus</> : null}
                                            </Grid>

                                            <Grid size={{xs: 8, md: 6, lg: 4}}>
                                                <Tooltip title={id ? "Mentés" : "Mentés és Feladatok létrehozása"}>
                                                    <Button fullWidth variant="contained" color="error" onClick={() => navigate(`/dashboard/product-projects/${productProject?.id}/iterations/${iteration?.id}/defect-report`)}>
                                                        Selejt jelentés
                                                    </Button>
                                                </Tooltip>
                                            </Grid>

                                            <Grid size={{xs: 8, md: 6, lg: 4}}>
                                                {waitingForServer ? <CircularProgress sx={{margin: "-5px"}}/> :
                                                    <Tooltip title={id ? "Mentés" : "Mentés és Feladatok létrehozása"}>
                                                        <Button type="submit" fullWidth variant="contained"
                                                                color="success">
                                                            Mentés
                                                        </Button>
                                                    </Tooltip>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </form>
                        </div>
                    </Grid>
                </Grid>
            </Paper>

            <Paper component="main" sx={{margin: "20px 0px", borderRadius: "5px"}}>
                <TableContainer style={{maxHeight: "calc(100vh - 360px)"}}>
                    <Table stickyHeader aria-label="sticky table" sx={{tableLayout: 'fixed'}}>
                        <TableHead>
                            <TableRow>
                                <TableCell style={{fontWeight: 700, background: "lightgray", width: "50px"}}></TableCell>
                                {columns.map((column, index) => (
                                    <TableCell key={index} align={column.align} style={{fontWeight: 700, background: "lightgray"}} width={column.width}>
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {iterationOptions == null ? <TableRow sx={{textAlign: "center"}}><TableCell sx={{
                                    padding: "200px",
                                    textAlign: "center"
                                }}><CircularProgress/></TableCell></TableRow> :
                                iterationOptions?.map((row, index) => {
                                    return <Row row={row} navigate={navigate} key={index} iteration={iteration} handleDialogOpen={handleDialogOpen} visibleColumns={visibleColumns}/>
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>

            <Dialog open={open} onClose={handleDialogClose}
                    PaperProps={{
                        component: 'form',
                        onSubmit: (e) => {
                            e.preventDefault();
                            const formData = new FormData(e.currentTarget);
                            const amount = formData.get('amount');
                            productService.moveProduct({
                                fromSubStorageId: dialogContent?.subStorageId,
                                subStorageId: iteration?.subStorage?.id,
                                productItemId: dialogContent?.productItemId,
                                amount: amount,
                            }).then(() => {
                                props.sendAlertMessage('Termékek mozgatása sikeres')
                                handleDialogClose()
                                props.retrieveProductProjectIteration()
                            })
                                .catch(error => props.sendAlertMessage(error?.message || "Termék mozgatása sikertelen", 'error'))
                        },
                    }}>
                <DialogTitle sx={{background: "#1976d2", color: "white"}}>
                    Mozgatandó termék mennyisége</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus required fullWidth margin="dense"
                        autoComplete="false"
                        name="amount"
                        label="Mennyiség"
                        defaultValue={dialogContent?.amount}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} color="error" variant="outlined">Mégse</Button>
                    <Button type="submit" variant="contained">Mentés</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

function createInputField(name, label, value, onChange, required = false, autoFocus = false, disabled = false, type = "text", multiline = false, lg = 10) {
    return (<Grid size={{xs: 40, md: 20, lg: lg}}>
        <TextField
            variant="outlined"
            margin="normal"
            required={required}
            fullWidth
            id={name}
            label={label}
            name={name}
            type={type}
            autoFocus={autoFocus}
            autoComplete="off"
            onChange={onChange}
            value={value || ""}
            disabled={disabled}
            multiline={multiline}
            minRows={multiline ? 5 : 1}
        />
    </Grid>)
}

function Row(props) {

    const {row, navigate, iteration, handleDialogOpen, visibleColumns} = props;
    const [open, setOpen] = React.useState(true);

    return (
        <React.Fragment>
            <TableRow sx={{'& > *': {borderBottom: 'unset !important'}}} onClick={() => setOpen(!open)}>
                <TableCell>
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUp/> : <KeyboardArrowDown/>}
                    </IconButton>
                </TableCell>
                {columns.map((column) => {
                    const value = column.fun ? column.fun(row[column.id], row, navigate, iteration) : row[column.id];
                    return (
                        <TableCell key={column.id} align={column.align} component="th" scope="row"
                                   sx={{cursor: "pointer", padding: "10px"}}>
                            {value}
                        </TableCell>
                    );
                })}
            </TableRow>
            <TableRow sx={{height: open ? '' : '0px'}}>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{margin: 1}}>
                            <Table size="small" aria-label="purchases" sx={{tableLayout: 'fixed'}}>
                                <TableHead>
                                    <TableRow>
                                        {visibleColumns.map((column, index) => (
                                            <TableCell key={index} align={column.align} style={{fontWeight: 700, background: "whitesmoke", width: column.width}}>
                                                {column.label}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {row.items?.map((item, index) => (
                                        <TableRow key={item.date} sx={{backgroundColor: item.shortageDueToReservations > 0 ? '#fff4aa' : ""}}>
                                            {visibleColumns.map((column) => {
                                                const value = column.fun ? column.fun(item[column.id], item, navigate, handleDialogOpen) : item[column.id];
                                                if (column.id === 'totalQuantityToOrder' && row.reasons[index - 1]?.shortageDueToReservations > 0) return <></>
                                                return (
                                                    <TableCell key={column.id} align={column.align} component="th" scope="row"
                                                               rowSpan={column.id === 'totalQuantityToOrder' && item.shortageDueToReservations > 0 ? 2 : 1}
                                                               sx={{padding: "0px", textAlign: column.align}}>
                                                        {value}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>

                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}